import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PartnerService } from '../../service/PartnerService';

const partnerService = new PartnerService();

const initialState = {
  partnerList: [],
  partnerListCount: 0,
  status: 'idle',
  error: null
};

export const getPartnersAsync = createAsyncThunk(
  'partnerList',
  async ({page = 0, first = 0, rows = 10, sortField = 'id', sortOrder = 1, filters = {}}, { rejectWithValue }) => {
    try {
      return await partnerService.getPartners(page, first, rows, sortField, sortOrder, filters);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao buscar parceiros');
    }
  }
);

export const getPartnersCountAsync = createAsyncThunk(
  'partnerListCount',
  async ({filters = {}}, { rejectWithValue }) => {
    try {
      return await partnerService.getCountPartners(filters);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao buscar contagem de parceiros');
    }
  }
);

export const initialLoadAsync = createAsyncThunk(
  'partnerInitialLoad',
  async ({page = 0, first = 0, rows = 10, sortField = 'id', sortOrder = 1, filters = {}}, { rejectWithValue }) => {
    try {
      const count = await partnerService.getCountPartners(filters);
      const list = await partnerService.getPartners(page, first, rows, sortField, sortOrder, filters);
      return {
        count,
        list
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao carregar dados iniciais');
    }
  }
);

export const deletePartnerAsync = createAsyncThunk(
  'deletePartner',
  async ({id, gridParameters}, { rejectWithValue }) => {
    try {
      await partnerService.deletePartner(id);
      const count = await partnerService.getCountPartners(gridParameters.filters);
      const list = await partnerService.getPartners(0, 0, gridParameters.rows, gridParameters.sortField, gridParameters.sortOrder, gridParameters.filters);
      return {
        count,
        list
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao excluir parceiro');
    }
  }
);

export const editPartnerAsync = createAsyncThunk(
  'editPartner',
  async ({partner, imageFile, logoFile, originalImage, originalLogo, gridParameters}, { rejectWithValue }) => {
    try {
      await partnerService.editPartner(partner, imageFile, logoFile, originalImage, originalLogo);
      const count = await partnerService.getCountPartners(gridParameters.filters);
      const list = await partnerService.getPartners(gridParameters.page, gridParameters.first, gridParameters.rows, gridParameters.sortField, gridParameters.sortOrder, gridParameters.filters);
      return {
        count,
        list
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao editar parceiro');
    }
  }
);

export const createPartnerAsync = createAsyncThunk(
  'createPartner',
  async ({partner, imageFile, logoFile, gridParameters}, { rejectWithValue }) => {
    try {
      await partnerService.createPartner(partner, imageFile, logoFile);
      const count = await partnerService.getCountPartners(gridParameters.filters);
      const list = await partnerService.getPartners(0, 0, gridParameters.rows, gridParameters.sortField, gridParameters.sortOrder, gridParameters.filters);
      return {
        count,
        list
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao criar parceiro');
    }
  }
);

export const partnerSlice = createSlice({
  name: 'partnerSlice',
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(initialLoadAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getPartnersAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getPartnersCountAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(initialLoadAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.partnerList = action.payload.list.data.map(d => {
          if (d.createdAt) {
            d.createdAtFormatted = new Date(d.createdAt).toLocaleDateString('pt-BR');
          }
          return d;
        });
        state.partnerListCount = action.payload.count;
        state.error = null;
      })
      .addCase(initialLoadAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(getPartnersAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.partnerList = action.payload.data.map(d => {
          if (d.createdAt) {
            d.createdAtFormatted = new Date(d.createdAt).toLocaleDateString('pt-BR');
          }
          return d;
        });
        state.error = null;
      })
      .addCase(getPartnersAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(getPartnersCountAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.partnerListCount = action.payload;
        state.error = null;
      })
      .addCase(getPartnersCountAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(createPartnerAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createPartnerAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.partnerList = action.payload.list.data;
        state.partnerListCount = action.payload.count;
        state.error = null;
      })
      .addCase(createPartnerAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(editPartnerAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(editPartnerAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.partnerList = action.payload.list.data;
        state.partnerListCount = action.payload.count;
        state.error = null;
      })
      .addCase(editPartnerAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(deletePartnerAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deletePartnerAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.partnerList = action.payload.list.data;
        state.partnerListCount = action.payload.count;
        state.error = null;
      })
      .addCase(deletePartnerAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const selectPartnerList = (state) => state.partner.partnerList;

export const selectPartnerListCount = (state) => state.partner.partnerListCount;

export const selectLoading = (state) => state.partner.status === 'loading';

export const selectError = (state) => state.partner.error;

export default partnerSlice.reducer;

